import React, {Component} from 'react';
import uaparser from 'ua-parser-js';
import PercentItem from './PercentItem';
import {FormattedMessage} from 'react-intl';

const browserNames = {
    'WebKit': 'Mobile Safari',
    'Chrome WebView': 'Android',
}
const deviceNames = {
    mobile: 'Mobile',
    tablet: 'iPad',
}

class TopBrowsers extends Component {
    state = {}

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    render() {
        const browserMap = {};
        const deviceMap = {};
        const osMap = {};
        this.props.visits.forEach(({user_agent}) => {
            const {browser, device, os} = uaparser(user_agent);
            if (browser && browser.name) {
                const name = browserNames[browser.name] || browser.name
                browserMap[name] = browserMap[name] ? browserMap[name] + 1 : 1;
            }
            if (device) {
                const type = deviceNames[device.type] || device.type || 'Desktop';
                deviceMap[type] = deviceMap[type] ? deviceMap[type] + 1 : 1;
            }
            if (os && os.name) {
                osMap[os.name] = osMap[os.name] ? osMap[os.name] + 1 : 1;
            }
        })
        const total = this.props.visits.length;
        const deviceArray = Object.keys(deviceMap).map((key) => {
            return {title: key, count: deviceMap[key], percent: Math.round((deviceMap[key] * 100) / total)}
        }).sort((a, b) => b.count - a.count).slice(0, 5)

        const browserArray = Object.keys(browserMap).map((key) => {
            return {title: key, count: browserMap[key], percent: Math.round((browserMap[key] * 100) / total)}
        }).sort((a, b) => b.count - a.count).slice(0, 5)
        const osArray = Object.keys(osMap).map((key) => {
            return {title: key, count: osMap[key], percent: Math.round((osMap[key] * 100) / total)}
        }).sort((a, b) => b.count - a.count).slice(0, 5)
        return (
            <>
                <div className="card">
                    <div className="card-header"><FormattedMessage id={"Browsers"}/></div>
                    <ul className="list-group list-group-flush">
                        {
                            browserArray.map((item) => {
                                return <li className="list-group-item">
                                    <PercentItem title={item.title} percent={item.percent}/>
                                </li>
                            })
                        }

                    </ul>
                </div>
                <div className="card">
                    <div className="card-header"><FormattedMessage id={"Operating Systems"}/></div>
                    <ul className="list-group list-group-flush">
                        {
                            osArray.map((item) => {
                                return <li className="list-group-item">
                                    <PercentItem title={item.title} percent={item.percent}/>
                                </li>
                            })
                        }

                    </ul>
                </div>
                <div className="card">
                    <div className="card-header"><FormattedMessage id={"Devices"}/></div>
                    <ul className="list-group list-group-flush">
                        {
                            deviceArray.map((item) => {
                                return <li className="list-group-item">
                                    <PercentItem title={item.title} percent={item.percent}/>
                                </li>
                            })
                        }

                    </ul>
                </div>
            </>
        );
    }
}


export default TopBrowsers;
